import { render, staticRenderFns } from "./TableShimmer.vue?vue&type=template&id=6e6baa78&scoped=true&"
import script from "./TableShimmer.vue?vue&type=script&lang=js&"
export * from "./TableShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6baa78",
  null
  
)

export default component.exports